import React, { PureComponent } from 'react';
import classNames from 'classnames';

const ssnFormatter = (value, toCode) => {
  const MIDDLE_DOT_CODE = 183;
  const dot = String.fromCharCode(MIDDLE_DOT_CODE);

  const matcher = /(\d{1,3})(\d{1,2})?(\d{1,4})?/;
  const [, first, second, last ] = (matcher.exec(value) || []);
  let result = '';

  if (first) {
    const ssnFirst = toCode ? first.replace(/\d/g, dot) : first;
    result += ssnFirst.length === 3
      ? ssnFirst + ' - '
      : ssnFirst;
  }

  if (second) {
    const ssnSecond = toCode ? second.replace(/\d/g, dot) : second;
    result += ssnSecond.length === 2
      ? ssnSecond + ' - '
      : ssnSecond;
  }

  if (last) {
    result += toCode ? last.replace(/\d/g, dot) : last;
  }

  return result;
};

class SsnField extends PureComponent {

  constructor(props) {
    super(props);
    this.inputRef = React.createRef();
  }

  state = {
    showText: false,
    showToggle: this.props.defaultValue ? true : null,
    showHide: true,
    value: this.props.defaultValue || null,
    currentPosition: 0
  }

  handleChange = (e) => {
    const currentVal = e.target.value && e.target.value.replace(/[\D]/g, '').trim();

    const showToggle = currentVal || true;
    const { value, showHide } = this.state;

    const { updateSsn } = this.props;

    // Adding value to hidden value
    if (showHide && value && currentVal && e.target.selectionStart > value.length) {
      const newValue = value + currentVal;
      return this.setState({ value: value + currentVal }, () => {
        typeof updateSsn === 'function' && updateSsn(newValue);
      });
    }

    // Removing value
    if (showHide && (value && !currentVal) && e.target.selectionStart <= 15) {
      let startPosOffset = 0;
      if (e.target.selectionStart > 7) {
        startPosOffset = 6;
      } else if (e.target.selectionStart > 3) {
        startPosOffset = 3;
      }

      const index = e.target.selectionStart - startPosOffset;

      const individualChars = [ ...value ];
      delete individualChars[index];

      return this.setState({ value: individualChars.join(''), currentPosition: index }, () => {
        this.inputRef.current.selectionStart = index + startPosOffset;
        this.inputRef.current.selectionEnd = index + startPosOffset;
      });
    }

    if (value === currentVal) {
      return this.setState({ value: value.slice(0, -1)});
    }

    const ssn = currentVal && currentVal.replace(/\-|\s/g, '').trim();

    this.setState({ showToggle, value: ssn }, () => {
      typeof updateSsn === 'function' && updateSsn(ssn);
    });
  }

  handleClick = (e) => {
    e && e.preventDefault();
    const { showHide } = this.state;
    this.setState({ showHide: !showHide });
  }

  handleBlur = (e) => {
    const { updateSsn } = this.props;
    if (typeof updateSsn === 'function') {
      const { value } = this.state;
      updateSsn(value, true);
    }
  }

  render() {
    const {
      helperText,
      className,
      inputClassName,
      errorMsg,
      htmlFor,
      labelText,
      labelClassName
    } = this.props;

    const {
      showToggle,
      showHide
    } = this.state;

    const value = ssnFormatter(this.state.value, showHide);

    const inputClassnames = classNames('input-element', {
      'input-element--code': showHide
    });

    return <div className={classNames('ssn-field', className)}>
      <div>
        <label htmlFor={htmlFor} className={classNames(labelClassName, { 'section-label--error': errorMsg })}>
          {labelText}
        </label>
        <div className={classNames('field-input txt-field-input ssn-field-input', inputClassName, {'field-input--error': errorMsg })}>
          <input
              data-test-id="ssn-field"
              autoComplete="off"
              className={classNames(inputClassnames, 'input-element')}
              ref={this.inputRef}
              type='tel'
              id={htmlFor}
              maxLength='15'
              value={value}
              display='text'
              placeholder= 'XXX - XX - XXXX'
              onChange={this.handleChange}
              onBlur={this.handleBlur}
          />
          { showToggle && <button onClick={this.handleClick} className='toggle-ssn-field'>{ showHide ? 'SHOW' : 'HIDE' }</button> }
        </div>
        { helperText && <div className={classNames('section-helper-txt')}>{helperText}</div> }
      </div>
      { errorMsg && <div className={'field-error-msg'}>{errorMsg}</div>}
    </div>;
  }
}

export default SsnField;

export {
  ssnFormatter
};

